import { render, staticRenderFns } from "./InformationHeader.vue?vue&type=template&id=cfd0f720&scoped=true&"
import script from "./InformationHeader.vue?vue&type=script&lang=js&"
export * from "./InformationHeader.vue?vue&type=script&lang=js&"
import style0 from "./InformationHeader.vue?vue&type=style&index=0&id=cfd0f720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd0f720",
  null
  
)

export default component.exports